import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'data-table',
  name: 'Data Table',
  category: 'database',
  description: 'Store and query data in built-in tables without external database setup',
  icon: 'Table2',
  color: 'emerald',
  version: '1.0.0',
  comingSoon: false,
  credentials: [],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'data_table',
    description: 'Store and query data in built-in tables. Supports CRUD operations, SQL queries, upsert, bulk operations, and table creation. Use this for persistent data storage without external database setup.',
    allowManualDescription: true,
    parameters: {
      tableId: {
        toolParamName: 'table_id',
        description: 'The ID of the data table to operate on (not required for createTable operation)',
        required: false,
        type: 'string',
      },
      operation: {
        toolParamName: 'operation',
        description: 'The operation to perform: createTable, getAll, getById, query, count, insert, update, upsert, delete, append, replaceAll, bulkUpdate, bulkDelete',
        required: true,
        type: 'string',
      },
      rowId: {
        toolParamName: 'row_id',
        description: 'The row ID (for getById, update, delete operations)',
        required: false,
        type: 'string',
      },
      query: {
        toolParamName: 'query',
        description: 'SQL query to execute (for query operation). Use @table as the table reference.',
        required: false,
        type: 'string',
      },
      data: {
        toolParamName: 'data',
        description: 'Row data as JSON object (for insert, update, upsert operations)',
        required: false,
        type: 'object',
      },
      upsertKey: {
        toolParamName: 'key_field',
        description: 'The field name to use as the key for upsert operations',
        required: false,
        type: 'string',
      },
      newTableName: {
        toolParamName: 'table_name',
        description: 'Name for the new table (for createTable operation)',
        required: false,
        type: 'string',
      },
      newTableSchema: {
        toolParamName: 'schema',
        description: 'Table schema with columns definition (for createTable operation)',
        required: false,
        type: 'object',
      },
    },
    outputMapping: {
      data: 'The query result rows or row data',
      rowCount: 'Number of rows affected or returned',
      count: 'Row count (for count operation)',
      id: 'Row ID (for insert, upsert operations)',
      tableId: 'Table ID (for createTable operation)',
      tableName: 'Table name (for createTable operation)',
      created: 'Whether a new table was created',
      tableCreated: 'Whether the table was auto-created (for write operations with createIfNotExists)',
    },
  },
};

export default definition;
